import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, uaeProjectsBaseURL, umsUrl } from '../../../../Containers/Config/index.js';
import { DOWNLOADS_LIST, DOWNLOADS_LIST_SUCCESS, DOWNLOADS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getDownloadsList({ payload }) {
  try {
    let url = payload?.code === 'customer' ? `${umsUrl}/admin/v1/download` : `${uaeProjectsBaseURL}/admin/downloadsInfo`;
    const response = yield call(apiCall, {
      url: url,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: DOWNLOADS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DOWNLOADS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOADS_LIST_ERROR, payload: error });
  }
}

export function* watchDownloadsList() {
  yield takeEvery(DOWNLOADS_LIST, getDownloadsList);
}

function* downloadsListSaga() {
  yield all([fork(watchDownloadsList)]);
}

export default downloadsListSaga;
